// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"276":"tag","378":"user","535":"login"}[chunkId] || chunkId) + "." + {"32":"c45a3f18","276":"4099ae8c","378":"519e9a51","486":"cca6f49a","535":"921fe689","796":"1d55c72b"}[chunkId] + ".chunk.css";
};